import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styled from "styled-components";
import { ParallaxProvider } from "react-scroll-parallax";

//images
import ArrowDownFull from "../assets/images/arrow-down-full.svg";

const BackLink = styled.div`
  padding: 30px 0 0;
  > a {
    font-family: "Courier New";
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-decoration: underline;
    color: black;
    &:hover {
      color: #d8127d;
    }
  }
  @media (max-width: 992px) {
    text-align: left;
  }
`;

const SideHeader = styled.h4`
  width: 90%;
  position: absolute;
  z-index: 10000;
  cursor: pointer;
  top: ${props => props.top || "100px"};
  > span {
    border-bottom-style: solid;
    border-bottom-width: 3px;
  }
  > img {
    display: block;
    margin: auto;
  }
  @media (max-width: 992px) {
    display: none;
  }
`;

class ForegroundLayer extends Component {
  render() {
    const { cideriesScrollTo, streetFoodScrollTo, faqScrollTo } = this.props;
    return (
      <ParallaxProvider>
        <Container fluid style={{ position: "absolute", top: 0, zIndex: 100 }}>
          <Row>
            <Col md={3}>
              <BackLink>
                <a href="https://www.wearehawkes.com">
                  Back to wearehawkes.com
                </a>
              </BackLink>
              <SideHeader top="530px" onClick={cideriesScrollTo}>
                <span>CIDERIES</span>
                <img src={ArrowDownFull} alt="Down Arrow Underline" />
              </SideHeader>
              <SideHeader top="1625px" onClick={streetFoodScrollTo}>
                <span>STREET FOOD</span>
                <img src={ArrowDownFull} alt="Down Arrow Underline" />
              </SideHeader>
              <SideHeader top="2625px" onClick={faqScrollTo}>
                <span>FAQs</span>
                <img src={ArrowDownFull} alt="Down Arrow Underline" />
              </SideHeader>
            </Col>
            <Col />
            <Col md={3}>
              <SideHeader top="530px" onClick={cideriesScrollTo}>
                <span>CIDERIES</span>
                <img src={ArrowDownFull} alt="Down Arrow Underline" />
              </SideHeader>
              <SideHeader top="1625px" onClick={streetFoodScrollTo}>
                <span>STREET FOOD</span>
                <img src={ArrowDownFull} alt="Down Arrow Underline" />
              </SideHeader>
              <SideHeader top="2625px" onClick={faqScrollTo}>
                <span>FAQs</span>
                <img src={ArrowDownFull} alt="Down Arrow Underline" />
              </SideHeader>
            </Col>
          </Row>
        </Container>
      </ParallaxProvider>
    );
  }
}

export default ForegroundLayer;
